var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-verfiy-mobile"},[_c('bind-mobile-number',{ref:"unbind"}),_c('verify-phone-code',{ref:"verify",attrs:{"verify-params":_vm.verifyParams},on:{"passVerify":_vm.passVerify,"cancel":_vm.cancelPass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }